// extracted by mini-css-extract-plugin
export default {"heading":"IndustrySection_heading__mYojh"};